import React from 'react'

export default ({ className = 'sidenote--info', children }) => {
  return (
    <div className={`sidenote ${className}`}>
      <div className="sidenote__content">{children}</div>
    </div>
  )
}
